import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

@Injectable( { providedIn: 'root' } )
export class AuthGuard implements CanActivate {

    constructor( private router: Router, private auth: AuthService ) {}

    canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot ): boolean {
        if ( localStorage.getItem( 'access_token' ) ) {
            return true;
        }

        this.router.navigate( [ 'auth/login' ] );
        return false;
    }
}
